export const screenerMultiple = [
  { text: 'May Select', value: 'May Select' },
  { text: 'Qualify', value: 'Qualify' },
  { text: 'Disqualify', value: 'Disqualify' },
];

export const screenerSingle = [
  { text: 'Qualify', value: 'Qualify' },
  { text: 'Disqualify', value: 'Disqualify' },
];
